import * as types from '@/store/modules/logistique/suiviProduction-mutation-type';
import * as allTypes from '@/store/mutation-type';
import genererCritereRecherche from '@/services/logistique/suiviProduction/genererCritereRecherche';

function initialState() {
  return {
    demandesEnAttentes: [],
    criteresRecherche: genererCritereRecherche(),
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_DEMANDES_EN_ATTENTES](state, value) {
    state.demandesEnAttentes = value;
  },
  [types.SET_CRITERE_RECHERCHE](state, critere) {
    state.criteresRecherche = critere;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {};

const getters = {
  demandesEnAttentes: state => {
    return state.demandesEnAttentes;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
